import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './pages/footer/footer.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true, // Si tu componente usa standalone
  imports: [NavbarComponent,RouterOutlet,FooterComponent,CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
}) 
export class AppComponent implements OnInit{
  loading: boolean = true;
  progress: number = 0;

  ngOnInit() {
    const interval = setInterval(() => {
      if (this.progress < 100) {
        this.progress += 5; // Incremento cada 100ms (ajústalo si quieres)
      } else {
        clearInterval(interval);
        setTimeout(() => {
          this.loading = false;
        }, 500); // Pequeña pausa antes de ocultar el preloader
      }
    }, 100);
  }
  
  title = 'Tropilleros';
}
